import(/* webpackMode: "eager" */ "/codebuild/output/src35030413/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
